var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartwatchAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98338 2C9.14656 2 8.39821 2.52098 8.10774 3.30577L7.65967 4.51635C7.7717 4.50553 7.88527 4.5 8.00013 4.5H16.0001C16.115 4.5 16.2286 4.50553 16.3406 4.51635L15.8925 3.30577C15.6021 2.52098 14.8537 2 14.0169 2H9.98338Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65967 19.4837C7.7717 19.4945 7.88527 19.5 8.00013 19.5H16.0001C16.115 19.5 16.2286 19.4945 16.3406 19.4837L15.8925 20.6942C15.6021 21.479 14.8537 22 14.0169 22H9.98338C9.14656 22 8.39821 21.479 8.10774 20.6942L7.65967 19.4837Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6C6.89543 6 6 6.89543 6 8V16C6 17.1046 6.89543 18 8 18H16C17.1046 18 18 17.1046 18 16V8C18 6.89543 17.1046 6 16 6H8ZM12.75 9V11.6893L14.5303 13.4697C14.8232 13.7626 14.8232 14.2374 14.5303 14.5303C14.2374 14.8232 13.7626 14.8232 13.4697 14.5303L11.4697 12.5303C11.329 12.3897 11.25 12.1989 11.25 12V9C11.25 8.58579 11.5858 8.25 12 8.25C12.4142 8.25 12.75 8.58579 12.75 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartwatchAlt);
export default __webpack_public_path__ + "static/media/smartwatch-alt.bd4771eec4cd492f592e838d63cb659e.svg";
export { ForwardRef as ReactComponent };